define('models/pages/multi-account/page',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var Page = Model.extend({
        defaults: {
        },
        operationTransferInit: function(contractorId, currencyId, value, cb) {
            this.ajax('/api/multi-account/transfer/init', 'POST', {
                contractorId: contractorId,
                currencyId: currencyId,
                value: value
            })
            .then(function(data) {
                cb(data.error, data);
            });
        },

        operationTransferConfirm: function(privateKey, publicKey, cb) {
            return this.ajax('/api/multi-account/transfer/confirm', 'POST', {
                privateKey: privateKey,
                publicKey: publicKey
            })
            .then(function(data) {
                cb(data.error, data);
            });
        }
    });

    return Page;
});
